import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetCreatableRolesRequestDtoSchema = z.object();

const GetCreatableRolesResponseDtoSchema = z.array(
  z.object({
    id: z.number(),
    name: z.string(),
  })
);

export type GetCreatableRolesRequestDto = z.infer<
  typeof _GetCreatableRolesRequestDtoSchema
>;
export type GetCreatableRolesResponseDto = z.infer<
  typeof GetCreatableRolesResponseDtoSchema
>;

export const getCreatableRoles = (
  config?: AxiosRequestConfig<GetCreatableRolesRequestDto>
) => {
  return api
    .get('/roles/me/assignable-roles', config)
    .then(responseContract(GetCreatableRolesResponseDtoSchema));
};
